/*!
 * jQuery UI Widget-factory plugin boilerplate (for 1.8/9+)
 * Author: @addyosmani
 * Further changes: @peolanha
 * Licensed under the MIT license
 */

require('./jquery-ui.touchSpinner.js');

if (typeof ('pad') != 'function') {
	var pad = function (number, length) {

		var str = '' + number;
		while (str.length < length) {
			str = '0' + str;
		}

		return str;
	};
}

(function ($, window, document, undefined) {

	$.widget("badmath.timecodeField", {

		_hours: 0,
		_minutes: 0,
		_seconds: 0,
		_hoursObj: null,
		_minutesObj: null,
		_secondsObj: null,
		_minSecondCount: 0,
		_maxSecondCount: 23 * 60 * 60 + 59 * 60 + 59,
		_max: {},
		_min: {},
		_handleSpinDfd: null,

		//Options to be used as defaults
		options: {
			timecode: '',
			min: '00:00:00',
			max: '23:59:59',
			classPrefix: '',
			change: function (newValue) {}
		},

		//Setup widget (eg. element creation, apply theming
		// , bind events etc.)
		_create: function () {
			var plugin = this;
			var parts = plugin.options.timecode.split(':');

			plugin._hours = Number(parts[0]);
			plugin._minutes = Number(parts[1]);
			plugin._seconds = Number(parts[2]);

			plugin._minSecondCount = plugin._toSeconds(plugin.options.min);
			parts = plugin.options.min.split(':');
			plugin._min = {
				'hours': Number(parts[0]),
				'minutes': Number(parts[1]),
				'seconds': Number(parts[2])
			};
			plugin._maxSecondCount = plugin._toSeconds(plugin.options.max);
			parts = plugin.options.max.split(':');
			plugin._max = {
				'hours': Number(parts[0]),
				'minutes': Number(parts[1]),
				'seconds': Number(parts[2])
			};

			//add inputs for each sub field
			plugin._hoursObj = $('<input readonly>')
				.addClass(plugin._prefixClass('tcOverlayField'))
				.addClass(plugin._prefixClass('hours'))
				.data('min', 0)
				.data('max', 23)
				.data('field', '_hours')
				.val(plugin._hours);

			plugin._minutesObj = $('<input readonly>')
				.addClass(plugin._prefixClass('tcOverlayField'))
				.addClass(plugin._prefixClass('minutes'))
				.data('min', 0)
				.data('max', 59)
				.data('field', '_minutes')
				.val(plugin._minutes);

			plugin._secondsObj = $('<input readonly>')
				.addClass(plugin._prefixClass('tcOverlayField'))
				.addClass(plugin._prefixClass('seconds'))
				.data('min', 0)
				.data('max', 59)
				.data('field', '_seconds')
				.val(plugin._seconds);

			plugin._hoursObj.data('next', plugin._minutesObj);
			plugin._minutesObj.data('prev', 'hours');
			plugin._secondsObj.data('prev', 'minutes');

			plugin.element
				.append(plugin._hoursObj)
				.append(':')
				.append(plugin._minutesObj)
				.append(':')
				.append(plugin._secondsObj);

			plugin._initializeSpinners();
		},

		// Destroy an instantiated plugin and clean up
		// modifications the widget has made to the DOM
		_destroy: function () {
			this.element.empty();
		},

		_prefixClass: function (className) {
			return this.options.classPrefix + className;
		},

		_handleSpin: function (el, newValue) {
			var plugin = this;
			var badValue = false;
			var prevEl = null;
			if (plugin._handleSpinDfd && plugin._handleSpinDfd.state() == 'pending') {
				console.log('deferred is running');
				return;
			}
			plugin._handleSpinDfd = new $.Deferred();
			newValue = Number(newValue);

			if (newValue > Number(el.data('max'))) {

				if (el.data('prev')) {
					prevEl = plugin.element.find('.' + el.data('prev'));

					el.touchSpinner('value', el.data('min'));
					plugin[el.data('field')] = el.data('min');
					plugin[prevEl.data('field')] = prevEl.touchSpinner('value') + 1;
					prevEl.touchSpinner('value', prevEl.touchSpinner('value') + 1);
					plugin[el.data('field')] = el.touchSpinner('value');
				}

				badValue = true;

			} else if (newValue < Number(el.data('min'))) {
				if (el.data('prev')) {
					prevEl = plugin.element.find('.' + el.data('prev'));

					el.touchSpinner('value', el.data('max'));
					plugin[el.data('field')] = el.data('max');
					plugin[prevEl.data('field')] = prevEl.touchSpinner('value') - 1;
					prevEl.touchSpinner('value', prevEl.touchSpinner('value') - 1);

					plugin[el.data('field')] = el.touchSpinner('value');
				}

				badValue = true;
			} else {
				plugin[el.data('field')] = newValue;
			}
			if (plugin._toSeconds(plugin.value()) < plugin._minSecondCount) {
				plugin.element.find('.ui-spinner-down').addClass('disabled');
				plugin.value(plugin.options.min);
				badValue = true;

			} else if (plugin._toSeconds(plugin.value()) > plugin._maxSecondCount) {
				plugin.element.find('.ui-spinner-up').addClass('disabled');
				plugin.value(plugin.options.max);
				badValue = true;
			} else {

				plugin._disableButtons();
				plugin.options.change(plugin.value());

			}
			plugin._handleSpinDfd.resolve();
			return !badValue;
		},

		_fixTouch: function () {
			var plugin = this;

			$(document).on('touchend', function (e) {
				//
				//alert('blur');
				//$(this).focus();
				plugin.element.find('.' + plugin._prefixClass('tcOverlayField')).trigger('blur');
				//plugin.element.find('.' +plugin._prefixClass('tcOverlayField')).touchSpinner('stop');
			});
		},

		_disableButtons: function () {
			var plugin = this;
			var value = plugin.value();
			plugin.element.find('.ui-spinner-button').removeClass('disabled');

			if (plugin._hours >= plugin._max.hours) {
				plugin._hoursObj.siblings('.ui-spinner-up').addClass('disabled');
				if (plugin._minutes >= plugin._max.minutes) {
					plugin._minutesObj.siblings('.ui-spinner-up').addClass('disabled');
					if (plugin._seconds >= plugin._max.seconds) {
						plugin._secondsObj.siblings('.ui-spinner-up').addClass('disabled');
					}
				}
			}
			if (plugin._hours <= plugin._min.hours) {
				plugin._hoursObj.siblings('.ui-spinner-down').addClass('disabled');
				if (plugin._minutes <= plugin._min.minutes) {
					plugin._minutesObj.siblings('.ui-spinner-down').addClass('disabled');
					if (plugin._seconds <= plugin._min.seconds) {
						plugin._secondsObj.siblings('.ui-spinner-down').addClass('disabled');
					}
				}
			}
		},

		_initializeSpinners: function () {
			var plugin = this;

			plugin.element.find('.' + plugin._prefixClass('tcOverlayField')).each(function () {
				var el = $(this);
				el.touchSpinner({

					numberFormat: 'd2',
					spin: function (event, ui) {
						return plugin._handleSpin(el, ui.value);
					},
					change: function (event, ui) {

						//return plugin._handleSpin(el, el.touchSpinner('value'));
					}
				});
			});
			plugin._disableButtons();
			plugin._fixTouch();
		},

		_toSeconds: function (value) {
			var parts = value.split(':');
			return (60 * 60 * Number(parts[0])) + (60 * Number(parts[1])) +
				Number(parts[2]);
		},

		value: function (val) {
			var plugin = this;
			if (val !== undefined) {
				var parts = val.split(':');
				plugin._hours = Number(parts[0]);
				plugin._minutes = Number(parts[1]);
				plugin._seconds = Number(parts[2]);

				plugin._hoursObj.touchSpinner('value', plugin._hours);
				plugin._minutesObj.touchSpinner('value', plugin._minutes);
				plugin._secondsObj.touchSpinner('value', plugin._seconds);

				plugin.options.change(plugin.value());
			}
			return pad(this._hours, 2) + ':' + pad(this._minutes, 2) + ':' +
				pad(this._seconds, 2);
		}
	});

})(jQuery, window, document);
